/*
scrollToTop
shows hide button after scrolling
scrolls to top after click on button

IMPORTANT!
Some things are very similar to articleList.js

tobias.wolf@wagnerwagner.de
*/


(function () {
  // elements
  const element = document.querySelector('.scroll-to-top');

  // functions
  function calculateDuration() {
    let duration = 0;
    const scrollTop = document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
    duration = Math.abs(scrollTop) / 4;
    duration = duration > 1500 ? 1500 : duration;
    return duration;
  }
  function handleScroll() {
    // like articleList
    const scrollTop = document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
    let toggleTop = 400;
    if (document.querySelector('.mod_article:nth-child(2)')) {
      // 64 is margin-bottom of .text-teaser
      toggleTop = document.querySelector('.mod_article:nth-child(2)').offsetTop - 64;
    }
    if (scrollTop >= toggleTop) {
      // Scroll 64 Pixel for full opacity
      let opacity = (scrollTop - toggleTop) / 64;
      opacity = opacity > 1 ? 1 : opacity;
      element.classList.add('is-visible');
      element.style.opacity = opacity;
    } else {
      element.classList.remove('is-visible');
      element.style.opacity = null;
    }
  }
  function handleClick() {
    const duration = calculateDuration();
    SCROLLING.scrollTop(null, 0, duration);
    ARTICLE_LIST.hide();
    window.history.replaceState(null, null, location.pathname);
  }

  // event listeners
  if (element) {
    document.addEventListener('scroll', handleScroll);
    element.addEventListener('click', handleClick);
  }
}());
